import React from "react";
import { Mail } from "lucide-react";
import { Logo } from "./Logo";
import { AREA_LOCATIONS } from "../../data";
import { MAJOR_PROJECTS, HOME_SERVICES } from "../../content/hubs";

const CONTACT_EMAIL = "business@homeproconnectsc.com";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-[#173042] text-white pb-24 lg:pb-0">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-20">
        <div className="grid md:grid-cols-12 gap-12">
          <div className="md:col-span-4">
            <Logo light />
            <p className="mt-6 max-w-sm text-white/70 leading-relaxed text-[15px]">
              Home Pro Connect helps Lowcountry homeowners connect with a general contractor
              for major projects and with specialists for everyday home services.
            </p>
            <a
              href="/#request"
              data-testid="footer-cta"
              className="mt-7 inline-flex items-center rounded-full bg-[#54BCE6] text-[#133955] px-7 py-3.5 font-bold hover:bg-white transition-colors duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-[#173042]"
            >
              Request a Connection
            </a>
            <p className="mt-7 text-white/70 leading-relaxed text-sm">
              {AREA_LOCATIONS.filter((c) => !c.startsWith("Surrounding")).join(" · ")} and surrounding Lowcountry &amp; Grand Strand communities in South Carolina.
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="text-xs uppercase tracking-[0.2em] font-bold text-[#54BCE6] mb-5">Major Projects</p>
            <ul className="space-y-3 text-white/75">
              <li><a href="/sc/major-projects/" data-testid="footer-major-hub" className="hover:text-white transition-colors font-semibold">All Major Projects</a></li>
              {MAJOR_PROJECTS.map((p) => (
                <li key={p.slug}>
                  <a href={`/sc/major-projects/${p.slug}/`} data-testid={`footer-major-${p.slug}`} className="hover:text-white transition-colors">{p.name}</a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="text-xs uppercase tracking-[0.2em] font-bold text-[#54BCE6] mb-5">Home Services</p>
            <ul className="space-y-3 text-white/75">
              <li><a href="/sc/home-services/" data-testid="footer-services-hub" className="hover:text-white transition-colors font-semibold">All Home Services</a></li>
              {HOME_SERVICES.map((p) => (
                <li key={p.slug}>
                  <a href={`/sc/home-services/${p.slug}/`} data-testid={`footer-service-${p.slug}`} className="hover:text-white transition-colors">{p.name}</a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <p className="text-xs uppercase tracking-[0.2em] font-bold text-[#54BCE6] mb-5">Company</p>
            <ul className="space-y-3 text-white/75">
              <li><a href="/blog/" data-testid="footer-blog" className="hover:text-white transition-colors">Blog</a></li>
              <li><a href="/#how-it-works" className="hover:text-white transition-colors">How It Works</a></li>
              <li><a href="/#faq" className="hover:text-white transition-colors">FAQ</a></li>
              <li className="flex items-center gap-2 pt-2">
                <Mail size={16} className="text-[#54BCE6] shrink-0" />
                <a href={`mailto:${CONTACT_EMAIL}`} data-testid="footer-email" className="hover:text-white transition-colors break-all">{CONTACT_EMAIL}</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col gap-6">
          <div className="flex flex-wrap items-center gap-x-8 gap-y-3">
            <a href="/privacy" data-testid="footer-privacy" className="text-white/75 hover:text-white transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#54BCE6] rounded-sm">
              Privacy Policy
            </a>
            <a href="/terms" data-testid="footer-terms" className="text-white/75 hover:text-white transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#54BCE6] rounded-sm">
              Terms &amp; Disclosures
            </a>
          </div>

          <div className="flex flex-col md:flex-row md:items-end justify-between gap-6">
            <p className="text-sm text-white/55 max-w-3xl leading-relaxed">
              Home Pro Connect is a homeowner-to-contractor connection and referral service.
              We help introduce homeowners to contractors whose services and coverage area may
              align with a project. We do not perform, supervise, warrant, or guarantee any
              construction work, and contractors are independent third parties.
            </p>
            <p className="text-xs text-white/50 whitespace-nowrap">
              © {new Date().getFullYear()} Home Pro Connect
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
